export default {
    STATUS_401_UNAUTHORIZED: 'STATUS_401_UNAUTHORIZED',
    DELETE_BLOCK: 'DELETE_BLOCK',
    LOGOFF: 'LOGOFF',
    PROJECT_SHORTCUTS_UPDATED: 'PROJECT_SHORTCUTS_UPDATED',
    FOLDER_CONTEXT_MENU: 'FOLDER_CONTEXT_MENU',
}
